import { ApiService } from '../../service/api/ApiService'

/**
 * @type {string} Endpoint получения всех пользователей
 */
const allUsersEndpoint = 'users'
const usersEndpoint = 'users'
const userEndpoint = 'users/{id}'

/**
 * Метод получающий пользователей.
 *
 * @param context Стейт
 * @returns {Promise<null|*>}
 */
const findAllUsers = async (context) => {
    context.commit('fetchUsers')
    try {
        const response = await ApiService.get(allUsersEndpoint)
        context.commit('fetchUsersSuccess', response.data.data)
        return response.data.data
    } catch (e) {
        const error = ApiService.handleError(e)
        context.commit('fetchUsersError', error)
        return null
    }
}

const createUserProfile = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  try {
    const { data } = await ApiService.post(usersEndpoint, formData)
    const response = data === undefined ? null : data
    context.commit('createUserSuccess', response)
    context.commit('snackBarModules/showSuccessModal', 'Пользователь успешно создан', { root: true })
    context.dispatch('findAllUsers')
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    // context.commit('createUserError', error)
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  }
}

const findByUserId = async (context, id) => {
  context.commit('fetchUser')
  try {
    const { data } = await ApiService.get(userEndpoint.replace('{id}', id))
    const response = data === undefined ? null : data
    context.commit('fetchUserSuccess', response)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchUserError', error)
    return null
  }
}


const updateUserProfile = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  try {
    const { data } = await ApiService.put(userEndpoint.replace('{id}', formData.id), formData)
    const response = data === undefined ? null : data
    console.log(formData)
    context.commit('updateUserSuccess', response)
    context.commit('snackBarModules/showSuccessModal', 'Успешно обновлено', { root: true })
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    // context.commit('updateUserError', error)
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  }
}

export default {
    findAllUsers, createUserProfile, findByUserId, updateUserProfile
}


